export class FacilityFilterModel {
    public companyId: number;
    public status: string;
    public filterKey: string;

    constructor() {
        this.status = '';
    }
}
